import { signOut } from "firebase/auth";
import React, { useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { Link, NavLink } from "react-router-dom";
import auth from "../../firebase.init";

const Header = () => {
  const [dark, setDark] = useState(false);
  const [user] = useAuthState(auth);
  const logout = () => {
    signOut(auth);
  };
  // console.log(user.reloadUserInfo.photoUrl)

  return (
    <div data-theme={dark ? "dark" : "light"} className="sticky top-0 z-50">
      <div class="navbar bg-base-200">
        <div class="navbar-start">
          <div class="dropdown">
            <label tabindex="0" class="btn btn-ghost lg:hidden">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 6h16M4 12h8m-8 6h16"
                />
              </svg>
            </label>
            <ul
              tabindex="0"
              class="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52"
            >
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about">About</Link>
              </li>
              <li>
                <NavLink to="/blogs">Blogs</NavLink>
              </li>
            
              <li>
                <NavLink to="/Contact">Contact</NavLink>
              </li>
              {user ? (
              <>
                <button onClick={logout} className="btn btn-base-200">
                  <div class="avatar online p-2">
                    <div class="w-8 rounded-full">
                      {
                        user?.reloadUserInfo?.photoUrl ?  <img src={user?.reloadUserInfo?.photoUrl} alt="User" /> : <img src="https://api.lorem.space/image/face?hash=28212" />
                      }
                      
                    </div>
                  </div>
                  SignOut
                </button>
              </>
            ) : (
              <li>
                <Link to="/login">Login</Link>
              </li>
            )}
              <li>
                <NavLink to="/projectDetails">Project</NavLink>
              </li>
            </ul>
          </div>

          <a class="btn btn-ghost normal-case text-xl">DevOmar</a>
        </div>
        <div class="navbar-center hidden lg:flex">
          <ul class="menu menu-horizontal p-0">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="about">About</Link>
            </li>

            <li>
              <Link to="projectDetails">Project</Link>
            </li>

            
            <li>
              <NavLink to="blogs">Blogs</NavLink>
            </li>
            <li>
              <Link to="training"><i class="fa-solid fa-gift"></i>Training</Link>
            </li>
          
            {user ? (
              <>
                <button onClick={logout} className="btn btn-base-200">
                  <div class="avatar online p-2">
                    <div class="w-8 rounded-full">
                      {
                        user?.reloadUserInfo?.photoUrl ?  <img src={user?.reloadUserInfo?.photoUrl} alt="User" /> : <img src="https://api.lorem.space/image/face?hash=28212" />
                      }
                      
                    </div>
                  </div>
                  SignOut
                </button>
              </>
            ) : (
              <li>
                <Link to="/login">Login</Link>
              </li>
            )}
            <label class="swap swap-rotate">
              <input type="checkbox" onClick={() => setDark(!dark)} />

              <svg
                class="swap-on fill-current w-10 h-10"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path d="M5.64,17l-.71.71a1,1,0,0,0,0,1.41,1,1,0,0,0,1.41,0l.71-.71A1,1,0,0,0,5.64,17ZM5,12a1,1,0,0,0-1-1H3a1,1,0,0,0,0,2H4A1,1,0,0,0,5,12Zm7-7a1,1,0,0,0,1-1V3a1,1,0,0,0-2,0V4A1,1,0,0,0,12,5ZM5.64,7.05a1,1,0,0,0,.7.29,1,1,0,0,0,.71-.29,1,1,0,0,0,0-1.41l-.71-.71A1,1,0,0,0,4.93,6.34Zm12,.29a1,1,0,0,0,.7-.29l.71-.71a1,1,0,1,0-1.41-1.41L17,5.64a1,1,0,0,0,0,1.41A1,1,0,0,0,17.66,7.34ZM21,11H20a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Zm-9,8a1,1,0,0,0-1,1v1a1,1,0,0,0,2,0V20A1,1,0,0,0,12,19ZM18.36,17A1,1,0,0,0,17,18.36l.71.71a1,1,0,0,0,1.41,0,1,1,0,0,0,0-1.41ZM12,6.5A5.5,5.5,0,1,0,17.5,12,5.51,5.51,0,0,0,12,6.5Zm0,9A3.5,3.5,0,1,1,15.5,12,3.5,3.5,0,0,1,12,15.5Z" />
              </svg>

              <svg
                class="swap-off fill-current w-10 h-10"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path d="M21.64,13a1,1,0,0,0-1.05-.14,8.05,8.05,0,0,1-3.37.73A8.15,8.15,0,0,1,9.08,5.49a8.59,8.59,0,0,1,.25-2A1,1,0,0,0,8,2.36,10.14,10.14,0,1,0,22,14.05,1,1,0,0,0,21.64,13Zm-9.5,6.69A8.14,8.14,0,0,1,7.08,5.22v.27A10.15,10.15,0,0,0,17.22,15.63a9.79,9.79,0,0,0,2.1-.22A8.11,8.11,0,0,1,12.14,19.73Z" />
              </svg>
            </label>
           
          </ul>
        </div>

      </div>
    </div>
  );
};

export default Header;
// echo "# DevOmarPortfolio" >> README.md
// git init
// git add README.md
// git commit -m "first commit"
// git branch -M main
// git remote add origin https://github.com/omarfarukesham/DevOmarPortfolio.git
// git push -u origin main
// Write a function in js where every 5 seconds add a new row to the table with random data.
// Add those headers to the table thead row.
// ID -> Integer
// name -> string
// user -> string
// status -> [Active, Inactive, Suspend]
// <table id="box">

// </table>

// <script>
// var headers = ['ID', 'Name', 'User', 'Status']
// function tablegeneration() {
// //code in here
// }
// </script>
